(function () {
  var KO = window.KO || {};

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var format = KO.moneyFormat || "${{amount}}";
    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, "."))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, "."))
      .replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function openDrawer(id) {
    var root = document.getElementById(id);
    if (!root) return;
    root.hidden = false;
    document.body.style.overflow = "hidden";
    var focusable = root.querySelector("input, button, a");
    if (focusable) focusable.focus();
  }
  function closeDrawers() {
    qsa(".drawer-root, #MenuDrawer").forEach(function (el) { el.hidden = true; });
    document.body.style.overflow = "";
  }

  qsa("[data-open]").forEach(function (btn) {
    btn.addEventListener("click", function () { openDrawer(btn.getAttribute("data-open")); });
  });
  qsa("[data-close]").forEach(function (btn) {
    btn.addEventListener("click", closeDrawers);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeDrawers();
  });

  var header = qs("[data-header]");
  function onScroll() {
    if (!header) return;
    header.classList.toggle("is-scrolled", window.scrollY > 8);
    header.classList.toggle("is-solid", window.scrollY > 8);
  }
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  function setCount(n) {
    qsa("[data-cart-count]").forEach(function (el) { el.textContent = String(n); });
  }

  function lineHTML(item) {
    var img = item.image
      ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, "_180x$1$2") + '" alt="">'
      : "";
    return (
      '<article class="line" data-line="' + item.key + '">' +
        '<a href="' + item.url + '">' + img + "</a>" +
        "<div><a href=\"" + item.url + "\">" + item.product_title + "</a>" +
        (item.variant_title ? '<p class="muted">' + item.variant_title + "</p>" : "") +
        '<div class="qty">' +
          '<button type="button" data-qty-change="-1" aria-label="Decrease">–</button>' +
          '<input value="' + item.quantity + '" inputmode="numeric" aria-label="Quantity" data-qty>' +
          '<button type="button" data-qty-change="1" aria-label="Increase">+</button>' +
        "</div></div>" +
        "<div><p>" + formatMoney(item.final_line_price) + '</p>' +
        '<button type="button" data-remove>Remove</button></div></article>'
    );
  }

  function renderCart(cart) {
    setCount(cart.item_count);
    var body = qs("[data-cart-body]");
    var foot = qs("[data-cart-foot]");
    var sub = qs("[data-cart-subtotal]");
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="empty-room"><h3>The cart is clear.</h3><p class="muted">When a work is chosen, it will wait here.</p></div>';
      if (foot) foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(lineHTML).join("");
    if (sub) sub.textContent = formatMoney(cart.total_price);
    if (foot) foot.hidden = false;
    bindLines(body);
  }

  function changeLine(key, qty) {
    return fetch(KO.routes.cartChange, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function bindLines(body) {
    qsa("[data-qty-change]", body).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var line = btn.closest("[data-line]");
        var input = qs("[data-qty]", line);
        var next = Math.max(0, parseInt(input.value || "1", 10) + parseInt(btn.getAttribute("data-qty-change"), 10));
        changeLine(line.getAttribute("data-line"), next);
      });
    });
    qsa("[data-remove]", body).forEach(function (btn) {
      btn.addEventListener("click", function () {
        changeLine(btn.closest("[data-line]").getAttribute("data-line"), 0);
      });
    });
  }

  function refreshCart() {
    return fetch(KO.routes.cart + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }
  refreshCart();

  qsa("form.product-form").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var data = new FormData(form);
      var payload = { id: data.get("id"), quantity: data.get("quantity") || 1 };
      if (data.get("selling_plan")) payload.selling_plan = data.get("selling_plan");
      fetch(KO.routes.cartAdd, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return refreshCart();
      }).then(function () { openDrawer("CartDrawer"); })
        .catch(function () { form.submit(); });
    });
  });

  qsa("[data-product]").forEach(function (root) {
    var jsonEl = qs("[data-product-json]", root);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var variants = product.variants || [];
    function selectedOptions() {
      return qsa("[data-option]", root).map(function (input) {
        if (input.type === "radio") return input.checked ? input.value : null;
        return input.value;
      }).filter(function (v) { return v !== null; });
    }
    function current() {
      var opts = selectedOptions();
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === opts[i]; });
      });
    }
    function apply() {
      var v = current();
      if (!v) return;
      var idInput = qs('[name="id"]', root);
      if (idInput) idInput.value = v.id;
      var price = qs("[data-price]", root);
      if (price) {
        var html = v.compare_at_price && v.compare_at_price > v.price
          ? "<s>" + formatMoney(v.compare_at_price) + "</s> " + formatMoney(v.price)
          : formatMoney(v.price);
        price.innerHTML = html;
      }
      var btn = qs("[data-add]", root);
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? (btn.getAttribute("data-label") || "Acquire") : "Sold out";
      }
      if (v.featured_media) {
        var img = qs(".gallery-main", root);
        if (img && v.featured_media.preview_image) {
          img.src = v.featured_media.preview_image.src;
          img.removeAttribute("srcset");
          img.alt = v.featured_media.alt || "";
        }
      }
      var url = new URL(window.location.href);
      url.searchParams.set("variant", v.id);
      window.history.replaceState({}, "", url);
    }
    qsa("[data-option]", root).forEach(function (input) {
      input.addEventListener("change", apply);
    });
    qsa("[data-thumb]", root).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var img = qs("[data-gallery-main]", root);
        if (img) {
          img.src = btn.getAttribute("data-src");
          img.alt = btn.getAttribute("data-alt") || "";
        }
        qsa("[data-thumb]", root).forEach(function (b) { b.removeAttribute("aria-current"); });
        btn.setAttribute("aria-current", "true");
      });
    });
  });

  var searchInput = qs("[data-search-input]");
  var suggest = qs("[data-suggest]");
  var searchTimer;
  if (searchInput && suggest) {
    searchInput.addEventListener("input", function () {
      clearTimeout(searchTimer);
      var q = searchInput.value.trim();
      if (q.length < 2) { suggest.innerHTML = ""; return; }
      searchTimer = setTimeout(function () {
        var url = KO.routes.suggest + "?q=" + encodeURIComponent(q) + "&resources[type]=product,article,page&resources[limit]=6&resources[options][unavailable_products]=last";
        fetch(url, { headers: { Accept: "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var res = (data.resources && data.resources.results) || {};
            var items = [].concat(res.products || [], res.articles || [], res.pages || []);
            suggest.innerHTML = items.map(function (item) {
              return '<a href="' + item.url + '">' + (item.title || item.name) + "</a>";
            }).join("") || '<p class="muted">Nothing under that name.</p>';
          }).catch(function () { suggest.innerHTML = ""; });
      }, 180);
    });
  }

  var note = qs("[data-cart-note]");
  if (note) {
    var noteTimer;
    note.addEventListener("input", function () {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch(KO.routes.cartUpdate, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ note: note.value })
        });
      }, 400);
    });
  }

  var hold = qs("[data-hold]");
  if (hold) {
    var held = false;
    try { held = window.localStorage.getItem("outley-field-held") === "1"; } catch (e) {}
    function paintHold() {
      hold.setAttribute("aria-pressed", held ? "true" : "false");
      hold.classList.toggle("is-on", held);
      hold.setAttribute("aria-label", held ? "Release this chamber" : "Hold this chamber");
      var svg = hold.querySelector("svg");
      if (svg) svg.setAttribute("fill", held ? "currentColor" : "none");
    }
    paintHold();
    hold.addEventListener("click", function () {
      held = !held;
      try { window.localStorage.setItem("outley-field-held", held ? "1" : "0"); } catch (e) {}
      paintHold();
    });
  }

  var doorLinks = qs("[data-door-links]");
  if (doorLinks) {
    qsa("[data-door-title]").forEach(function (card) {
      var button = document.createElement("button");
      button.type = "button";
      button.textContent = card.getAttribute("data-door-title");
      button.addEventListener("click", function () {
        openDoor(card.getAttribute("data-open-door"));
      });
      doorLinks.appendChild(button);
    });
  }

  function rootPath() {
    var root = (KO.routes && KO.routes.root) || "/";
    if (root.slice(-1) !== "/") root += "/";
    return root;
  }

  function closeSheet() {
    document.body.classList.remove("is-sheet");
    qsa("[data-sheet].is-open").forEach(function (el) { el.classList.remove("is-open"); });
    window.scrollTo({ top: 0, behavior: "auto" });
  }

  function openDoor(id) {
    var here = location.pathname === rootPath() || location.pathname === rootPath().slice(0, -1);
    if (!here) {
      location.href = rootPath() + "#door-" + id;
      return;
    }
    var sheet = qs('[data-door="' + id + '"]');
    if (!sheet) return;
    closeDrawers();
    qsa("[data-sheet].is-open").forEach(function (el) { el.classList.remove("is-open"); });
    sheet.classList.add("is-open");
    document.body.classList.add("is-sheet");
    window.scrollTo({ top: 0, behavior: "auto" });
  }

  function openNamed(name) {
    var here = location.pathname === rootPath() || location.pathname === rootPath().slice(0, -1);
    if (!here) {
      location.href = rootPath() + "#" + name;
      return;
    }
    var sheet = qs('[data-sheet="' + name + '"]');
    if (!sheet) {
      var target = document.getElementById(name);
      closeDrawers();
      closeSheet();
      if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
    closeDrawers();
    qsa("[data-sheet].is-open").forEach(function (el) { el.classList.remove("is-open"); });
    sheet.classList.add("is-open");
    document.body.classList.add("is-sheet");
    window.scrollTo({ top: 0, behavior: "auto" });
  }

  qsa("[data-open-door]").forEach(function (btn) {
    btn.addEventListener("click", function () { openDoor(btn.getAttribute("data-open-door")); });
  });
  qsa("[data-close-sheet]").forEach(function (btn) {
    btn.addEventListener("click", function () { closeSheet(); });
  });
  qsa("[data-goto]").forEach(function (btn) {
    btn.addEventListener("click", function () { openNamed(btn.getAttribute("data-goto")); });
  });

  qsa("[data-seed]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var id = btn.getAttribute("data-seed");
      qsa("[data-seed]").forEach(function (other) {
        var on = other === btn;
        other.classList.toggle("is-on", on);
        other.setAttribute("aria-selected", on ? "true" : "false");
      });
      qsa("[data-seed-panel]").forEach(function (panel) {
        panel.hidden = panel.getAttribute("data-seed-panel") !== id;
      });
      try { window.localStorage.setItem("outley-field-map", id); } catch (e) {}
      var out = qs("[data-map-out]");
      if (out) out.hidden = true;
    });
  });

  var mapForm = qs("[data-map-form]");
  if (mapForm) {
    mapForm.addEventListener("submit", function (event) {
      event.preventDefault();
      var input = qs("input[type='email']", mapForm);
      var noteEl = qs("[data-map-note]", mapForm);
      var valid = input && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim());
      if (!valid) {
        noteEl.hidden = false;
        noteEl.classList.add("is-bad");
        noteEl.textContent = "Enter a valid email address to open the map.";
        return;
      }
      noteEl.hidden = false;
      noteEl.classList.remove("is-bad");
      noteEl.textContent = "The map is open. You are on the list.";
      var trap = qs("input[name='contact[company]']", mapForm);
      if (!(trap && trap.value) && window.fetch && window.FormData) {
        try {
          fetch(mapForm.getAttribute("action") || "/contact", { method: "POST", body: new FormData(mapForm), credentials: "same-origin" })
            .then(function (res) { if (!res.ok && res.status >= 400) { noteEl.textContent = "The map is open. We could not save your email, so try again later."; } })
            .catch(function () { noteEl.textContent = "The map is open. We could not save your email, so try again later."; });
        } catch (e) {}
      }
      var on = qs("[data-seed].is-on");
      var id = on ? on.getAttribute("data-seed") : "";
      try { window.localStorage.setItem("outley-field-map", id); } catch (e) {}
      var panel = qs('[data-seed-panel="' + id + '"]');
      var out = qs("[data-map-out]");
      if (!panel || !out) return;
      var steps = qsa("li", panel).map(function (li, index) {
        var n = String(index + 1).padStart(2, "0");
        return '<div class="map-step"><span class="map-n">' + n + '</span><p><strong>' + li.childNodes[0].textContent.trim() + '</strong><span>' + (li.getAttribute("data-note") || "") + '</span></p></div>';
      }).join("");
      var heading = qs(".kicker", panel);
      var residual = qs("[data-residual]", panel);
      out.innerHTML = (heading ? '<p class="kicker mt-s">' + heading.textContent + '</p>' : '') + steps + (residual ? '<p class="lede mt-s">' + residual.textContent + '</p>' : '');
      out.hidden = false;
    });
  }

  var boot = qs("[data-open-on-load]");
  var hash = (location.hash || "").replace("#", "");
  if (boot) openNamed(boot.getAttribute("data-open-on-load"));
  else if (hash.indexOf("door-") === 0) openDoor(hash.slice(5));
  else if (hash === "archive" || hash === "contact") openNamed(hash);
  else if (hash) {
    var jump = document.getElementById(hash);
    if (jump) jump.scrollIntoView({ block: "start" });
  }
})();

/* correspondence is data only; it does not paint */
(function () {
  var node = document.getElementById("ko-correspondence");
  if (!node) return;
  var map = {};
  try { map = JSON.parse(node.textContent); } catch (e) { return; }
  Object.keys(map).forEach(function (key) {
    var el = document.getElementById(key) || document.querySelector("[data-field]#" + key);
    if (!el) el = document.getElementById(key);
    if (el) el.setAttribute("data-ko-ratio", String(map[key].ratio));
  });
  document.querySelectorAll("form").forEach(function (form) {
    form.addEventListener("submit", function (event) {
      var trap = form.querySelector('input[name="company"], input[name="contact[company]"]');
      if (trap && trap.value) event.preventDefault();
    });
  });
})();

/* free map signup: Shopify checks first (spam/bot protection), then Klaviyo sends the map.
   Real visitors never see a check. If Shopify suspects a bot it shows its own challenge page,
   and Klaviyo is only told after Shopify lets the signup through. */
(function () {
  var form = document.getElementById("Profile");
  if (!form || !window.fetch || !window.FormData) return;
  var kv = form.querySelector("[data-klaviyo]");
  var kCompany = kv && kv.getAttribute("data-company");
  var kList = kv && kv.getAttribute("data-list");
  var KEY = "ko-map-signup";

  function addToKlaviyo(p) {
    if (!kCompany || !kList || !p || !p.email) return Promise.resolve(false);
    return fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(kCompany), {
      method: "POST",
      keepalive: true,
      headers: { "Content-Type": "application/vnd.api+json", "revision": "2024-10-15" },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            custom_source: "Kydale.com Artist Asset Map",
            profile: { data: { type: "profile", attributes: {
              email: p.email, first_name: p.first || "", last_name: p.last || ""
            } } }
          },
          relationships: { list: { data: { type: "list", id: kList } } }
        }
      })
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }
  function stash(p) { try { window.sessionStorage.setItem(KEY, JSON.stringify(p)); } catch (e) {} }
  function unstash() {
    try {
      var v = window.sessionStorage.getItem(KEY);
      window.sessionStorage.removeItem(KEY);
      return v ? JSON.parse(v) : null;
    } catch (e) { return null; }
  }

  /* Came back from Shopify's challenge page after passing it: now tell Klaviyo. */
  if (window.location.search.indexOf("customer_posted=true") > -1) {
    var pending = unstash();
    if (pending) addToKlaviyo(pending);
  }

  form.addEventListener("submit", function (event) {
    if (form.checkValidity && !form.checkValidity()) return;
    event.preventDefault();
    var trap = form.querySelector("input[name='contact[company]']");
    var fields = form.querySelector("[data-profile-fields]");
    var done = form.querySelector("[data-profile-done]");
    var btn = form.querySelector("button[type='submit']");
    function show() {
      if (fields) fields.hidden = true;
      if (done) done.hidden = false;
    }
    if (trap && trap.value) { show(); return; }
    if (btn) { btn.disabled = true; btn.textContent = "Sending..."; }
    var emailEl = form.querySelector("input[name='contact[email]']");
    var firstEl = form.querySelector("input[name='contact[first_name]']");
    var lastEl = form.querySelector("input[name='contact[last_name]']");
    var person = {
      email: emailEl ? emailEl.value : "",
      first: firstEl ? firstEl.value : "",
      last: lastEl ? lastEl.value : ""
    };
    stash(person);
    fetch(form.getAttribute("action") || "/contact", { method: "POST", body: new FormData(form), credentials: "same-origin" })
      .then(function (res) {
        if (res.url && res.url.indexOf("customer_posted=true") > -1) {
          /* Shopify accepted it: add to Klaviyo, then show success */
          unstash();
          addToKlaviyo(person).then(show);
        } else {
          /* Shopify wants a check (suspected bot): show its challenge page */
          form.submit();
        }
      })
      .catch(function () { form.submit(); });
  });
})();

/* click-to-load embeds: nothing heavy loads until the visitor taps Play */
(function () {
  var warmed = {};
  function warm(url) {
    try {
      var origin = new URL(url).origin;
      if (warmed[origin]) return;
      warmed[origin] = 1;
      var l = document.createElement("link");
      l.rel = "preconnect";
      l.href = origin;
      document.head.appendChild(l);
    } catch (e) {}
  }
  function boxFor(target) {
    var btn = target && target.closest ? target.closest(".embed-facade__btn") : null;
    return btn ? btn.closest("[data-embed]") : null;
  }
  function load(box) {
    if (box.getAttribute("data-loaded")) return;
    box.setAttribute("data-loaded", "1");
    var src = box.getAttribute("data-src");
    if (box.getAttribute("data-autoplay")) src += (src.indexOf("?") > -1 ? "&" : "?") + "autoplay=1";
    var f = document.createElement("iframe");
    f.src = src;
    f.title = box.getAttribute("data-title") || "Embedded player";
    var allow = box.getAttribute("data-allow");
    if (allow) f.setAttribute("allow", allow);
    var sandbox = box.getAttribute("data-sandbox");
    if (sandbox) f.setAttribute("sandbox", sandbox);
    f.setAttribute("allowfullscreen", "");
    f.setAttribute("frameborder", "0");
    if (!box.classList.contains("embed-facade--video")) f.style.height = box.getAttribute("data-height") + "px";
    box.classList.add("is-loaded");
    box.innerHTML = "";
    box.appendChild(f);
  }
  document.addEventListener("click", function (e) {
    var box = boxFor(e.target);
    if (box) load(box);
  });
  ["pointerover", "touchstart"].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var box = boxFor(e.target);
      if (box) warm(box.getAttribute("data-src"));
    }, { passive: true });
  });
})();
